"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textColors = exports.borders = exports.sizes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var sizes = {
  sm: 'py-1 px-3 text-xs',
  md: 'py-2 px-4',
  lg: 'py-3 px-5'
};
exports.sizes = sizes;
var borders = {
  disabled: 'text-light border',
  normal: 'text-medium bg-secondary',
  invalid: 'border border-red'
};
exports.borders = borders;
var textColors = {
  disabled: 'text-light',
  normal: 'text-medium',
  invalid: ''
};
exports.textColors = textColors;

var _default = function _default(_ref) {
  var _cn, _cn2;

  var _ref$standalone = _ref.standalone,
      standalone = _ref$standalone === void 0 ? false : _ref$standalone,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["standalone", "disabled", "invalid", "size", "className"]);
  var sizeClasses = sizes[size];
  var classNames = (0, _classnames["default"])('rounded flex items-center', sizeClasses, className, (_cn = {}, (0, _defineProperty2["default"])(_cn, borders.disabled, disabled), (0, _defineProperty2["default"])(_cn, borders.normal, !disabled), (0, _defineProperty2["default"])(_cn, borders.invalid, invalid), _cn), (_cn2 = {}, (0, _defineProperty2["default"])(_cn2, textColors.normal, !disabled), (0, _defineProperty2["default"])(_cn2, textColors.disabled, disabled), (0, _defineProperty2["default"])(_cn2, textColors.invalid, invalid), _cn2));

  var props = _objectSpread({
    disabled: disabled,
    className: 'outline-none appearance-none pr-6 bg-transparent w-full'
  }, rest);

  var icon = /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
    fontSize: "small",
    className: "-ml-6 pointer-events-none"
  });

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames
  }, standalone ? /*#__PURE__*/_react["default"].createElement("select", props) : /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: props.name,
    render: function render(_ref2) {
      var field = _ref2.field,
          form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({}, props, field, {
        onChange: function onChange(e) {
          if (props.onChange) props.onChange(e, field, form);else field.onChange(e);
        }
      }));
    }
  }), icon);
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map